import React from 'react';
import { connect } from 'react-redux';

//Components

import SmartMenu from '../index';
import WpBadge from 'Wpds/components/badge/WpBadge';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { SmartLinkLogo } from '../../components';

//Selectors
import { getJiraSignUpUrl } from 'Shared/selectors/smartLinks';

//Logos
import jiraLogo from 'Shared/images/JiraLogo.png';

//Styles
import '../SmartMenu.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

//Helpers
import { trackClickedConnectApp } from 'Shared/tracking/tracking';
import { DataSourceSlugs } from 'Shared/constants/types';

const JiraIssueSmartMenu = ({ children, ...props }) => {
  const { tr } = useTranslation();
  const { hasJiraIntegration, jiraSignUpUrl } = props;

  const renderSmartLinkDetail = smart_link_detail => {
    const { status, assignee, assignee_avatar, reporter, reporter_avatar, status_category, change_summary } =
      smart_link_detail;
    const badgeColor = status_category === 'indeterminate' ? 'blue' : status_category === 'done' ? 'green' : 'gray';
    const assignee_initials = assignee
      ? assignee.includes(' ')
        ? assignee.substr(0, 1) + assignee.split(' ')[1].substr(0, 1)
        : assignee.substr(0, 1)
      : '';
    const assignee_display_avatar = assignee_avatar
      ? assignee_avatar
      : { initials: assignee_initials, color: '#34B5AD' };
    const reporter_initials = reporter
      ? reporter.includes(' ')
        ? reporter.substr(0, 1) + reporter.split(' ')[1].substr(0, 1)
        : reporter.substr(0, 1)
      : '';
    const reporter_display_avatar = reporter_avatar
      ? reporter_avatar
      : { initials: reporter_initials, color: '#F5C20D' };
    const className = 'SmartMenu__content__row';
    return (
      <>
        {reporter && (
          <div className={className}>
            <div className={`${className}__label`}>{tr('perform.smart_links.jira.reporter_label')}</div>
            <div className={`${className}__value`}>
              <WpAvatar size="sm" avatar={reporter_display_avatar}></WpAvatar>{' '}
              <div className={`${className}__value__text`}>{reporter}</div>
            </div>
          </div>
        )}
        <div className={className}>
          <div className={`${className}__label`}>{tr('perform.smart_links.jira.assignee_label')}</div>
          <div className={`${className}__value`}>
            {assignee && <WpAvatar size="sm" avatar={assignee_display_avatar}></WpAvatar>}
            {!assignee && (
              <span className={`${className}__empty-user-icon`}>
                <WpIcon name="user" size="md"></WpIcon>
              </span>
            )}{' '}
            <div className={`${className}__value__text`}>
              {assignee}
              {!assignee && tr('perform.smart_links.jira.unassigned')}
            </div>
          </div>
        </div>
        <div className={className}>
          {tr('perform.smart_links.jira.status_label')}{' '}
          <div className={`${className}__value`}>
            <WpBadge color={badgeColor} size="md">
              {status}
            </WpBadge>
          </div>
        </div>
        {change_summary && (change_summary.comments_added || 0) > 0 && (
          <div>{tr('perform.smart_links.jira.new_comments', String(change_summary.comments_added))}</div>
        )}
        <p />
        <a href={smart_link_detail.url} target="blank" rel="noopener norefferer">
          {tr('perform.smart_links.jira.view_issue')}
        </a>
      </>
    );
  };

  const renderSmartLinkBadge = smart_link_detail => {
    const { status, status_category } = smart_link_detail;
    if (!status) return null;
    const badgeColor = status_category === 'indeterminate' ? 'blue' : status_category === 'done' ? 'green' : 'gray';
    return (
      <div>
        <WpBadge color={badgeColor} size="md">
          {status}
        </WpBadge>
      </div>
    );
  };

  const handleConnectClick = () => {
    trackClickedConnectApp(DataSourceSlugs.jira);
    window.location.href = jiraSignUpUrl;
  };

  const renderEmbedingContent = () => {
    const className = 'SmartMenu__content__button';
    return (
      <>
        <div className={className}>To see more details about this link, connect your Jira account.</div>
        <p />
        <div className={className}>
          <WpButton variant="tertiary" onClick={handleConnectClick} block>
            Connect Jira
          </WpButton>
        </div>
      </>
    );
  };

  const menuTitle = smart_link_detail => (
    <>
      <SmartLinkLogo src={jiraLogo} />
      {smart_link_detail.uuid}
    </>
  );

  return (
    <SmartMenu
      hasDocumentIntegration={hasJiraIntegration}
      renderEmbedingContent={renderEmbedingContent}
      renderSmartLinkDetail={renderSmartLinkDetail}
      renderSmartLinkBadge={renderSmartLinkBadge}
      menuTitle={menuTitle}
      objectName="Jira Issue"
      {...props}
    >
      {children}
    </SmartMenu>
  );
};

const mapStateToProps = state => ({
  hasJiraIntegration: state.organization?.hasJiraIntegration,
  jiraSignUpUrl: getJiraSignUpUrl(state),
});

export default connect(mapStateToProps)(JiraIssueSmartMenu);
